import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, PLATFORM_ID } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import {
  RelatedPage,
  RelatedPagesComponent,
} from '../../partials/components/related-pages/related-pages.component';

@Component({
  selector: 'app-aml-compliance-software',
  imports: [MatIcon, RouterLink, RelatedPagesComponent],
  templateUrl: './aml-compliance-software.component.html',
  styleUrl: './aml-compliance-software.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmlComplianceSoftwareComponent {
  protected readonly relatedPages: RelatedPage[] = [
    {
      link: '/wallet-screening',
      anchor: "Crypto wallet screening",
      text: "The screening layer on its own: what an address has been close to, across four AML data providers.",
    },
    {
      link: '/transaction-monitoring',
      anchor: "Crypto transaction monitoring",
      text: "Continuous watch over the wallets you care about, with alerts in the dashboard and in Telegram.",
    },
    {
      link: '/alternatives/chainalysis',
      anchor: "Compared with Chainalysis",
      text: "Where the two tools differ, and which kind of compliance team each of them is built around.",
    },
    {
      link: '/alternatives/amlbot',
      anchor: "Compared with AMLBot",
      text: "A side-by-side look at coverage, team features and how each platform is run day to day.",
    },
    {
      link: '/pricing',
      anchor: 'Pricing and plans',
      text: 'Pro, Corporate and Enterprise plans, each with all four AML providers through one integration; per-report rates appear in your account after registration.',
    },
  ];

  private readonly _platformId = inject(PLATFORM_ID);

  readonly createAccountHref = computed(() => {
    if (!isPlatformBrowser(this._platformId)) {
      return 'https://app.amlofficer.org/register-corporate-account';
    }

    const referralLink = localStorage.getItem('referralLink');
    const trackingLink = localStorage.getItem('trackingLink');
    const queryParams = new URLSearchParams();
    if (referralLink) {
      queryParams.set('referralLink', referralLink);
    }
    if (trackingLink) {
      queryParams.set('trackingLink', trackingLink);
    }
    const query = queryParams.toString();
    return query
      ? `https://app.amlofficer.org/register-corporate-account?${query}`
      : `https://app.amlofficer.org/register-corporate-account`;
  });
}
